"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactSchema = exports.ContactInformationSchema = void 0;
/* eslint-disable camelcase */
const zod_1 = require("zod");
const base_1 = require("../base");
const addressSchema = zod_1.z.object({
    street: zod_1.z.string().optional(),
    city: zod_1.z.string().optional(),
    state: zod_1.z.string().optional(),
    zip: zod_1.z.string().optional(),
    country: zod_1.z.string().optional(),
    country_code: zod_1.z.string().optional(),
    type: zod_1.z.enum(["HOME", "WORK"]).optional(),
});
const emailSchema = zod_1.z.object({
    email: zod_1.z.string().optional(),
    type: zod_1.z.enum(["HOME", "WORK"]).optional(),
});
const nameSchema = zod_1.z.object({
    formatted_name: zod_1.z.string(),
    first_name: zod_1.z.string().optional(),
    last_name: zod_1.z.string().optional(),
    middle_name: zod_1.z.string().optional(),
    suffix: zod_1.z.string().optional(),
    prefix: zod_1.z.string().optional(),
});
const orgSchema = zod_1.z.object({
    company: zod_1.z.string().optional(),
    department: zod_1.z.string().optional(),
    title: zod_1.z.string().optional(),
});
const phoneSchema = zod_1.z.object({
    phone: zod_1.z.string().optional(),
    type: zod_1.z.enum(["CELL", "MAIN", "IPHONE", "HOME", "WORK"]).optional(),
    wa_id: zod_1.z.string().optional(),
});
const urlSchema = zod_1.z.object({
    url: zod_1.z.string().optional(),
    type: zod_1.z.enum(["HOME", "WORK"]).optional(),
});
exports.ContactInformationSchema = zod_1.z.object({
    addresses: zod_1.z.array(addressSchema).optional(),
    birthday: zod_1.z.string().optional(),
    emails: zod_1.z.array(emailSchema).optional(),
    name: nameSchema,
    org: orgSchema.optional(),
    phones: zod_1.z.array(phoneSchema).optional(),
    urls: zod_1.z.array(urlSchema).optional(),
});
exports.contactSchema = zod_1.z
    .object({
    kind: zod_1.z.literal("contact"),
    contacts: zod_1.z.array(exports.ContactInformationSchema),
})
    .merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.literal("bot") }));
//# sourceMappingURL=contact.js.map